"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.FieldValidation = React.createContext(null);
//# sourceMappingURL=context.js.map